<template>
  <div class="resource">
    <div class="resource-main">
      <div class="res-title" data-aos="fade-up" data-aos-duration="1000">
        <h3>产品资源</h3>
        <p>网银互联为您提供安全可靠的资源与管理服务</p>
      </div>
      <div class="res-wrap" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="200" :style="wrapHeight">
        <div class="wrap-box">
          <div class="wrap-item" @mouseenter="switchIndex(0)">
            <div class="wrap-pic">
              <i v-if="index == 0" class="iconfont icon-suanli icon-active"></i>
              <i v-else class="iconfont icon-suanli-samll"></i>
            </div>
            <h3>算力服务</h3>
          </div>
          <div class="wrap-item" @mouseenter="switchIndex(1)">
            <div class="wrap-pic">
              <i v-if="index == 1" class="iconfont icon-wangluochanpinyufuwuhover-01 icon-active"></i>
              <i v-else class="iconfont icon-wangluochanpinyufuwu-01"></i>
            </div>
            <h3>MDC网络融合服务</h3>
          </div>
          <div class="wrap-item" @mouseenter="switchIndex(2)">
            <div class="wrap-pic">
              <i v-if="index === 2" class="iconfont icon-ITjichuziyuanyufuwuhover-01 icon-active"></i>
              <i v-else class="iconfont icon-ITjichuziyuanyufuwu-01"></i>
            </div>
            <h3>IDC服务</h3>
          </div>
          <div class="wrap-item" @mouseenter="switchIndex(3)">
            <div class="wrap-pic">
              <i v-if="index === 3" class="iconfont icon-yunjisuanchanpinyufuwuhover-01 icon-active" style="font-size:60px"></i>
              <i v-else class="iconfont icon-yunjisuan" style="font-size:60px"></i>
            </div>
            <h3>其它服务</h3>
          </div>
          <div class="slide-bar" :style="slidePos"></div>
        </div>
        <div class="wrap-content" :style="index === 0 ? 'opacity: 1;z-index:999;' : 'opacity: 0;z-index:0'">
          <div class="wrap-content-item" v-for="(item, index) in contentGroupG" @click="toDetail(item.url, item.per)">
            <h3>{{ item.tit }}</h3>
            <p>{{ item.desc }}</p>
          </div>
        </div>
        <div class="wrap-content" :style="index === 1 ? 'opacity: 1;z-index:999;' : 'opacity: 0;z-index:0'">
          <div class="wrap-content-item" v-for="(item, index) in contentGroupB" @click="toDetail(item.url, item.per)">
            <h3>{{ item.tit }}</h3>
            <p>{{ item.desc }}</p>
          </div>
        </div>
        <div class="wrap-content" :style="index === 2 ? 'opacity: 1;z-index:999' : 'opacity: 0;z-index:0'">
          <div class="wrap-content-item" v-for="(item, index) in contentGroupC" @click="toDetail(item.url, item.per)">
            <h3>{{ item.tit }}</h3>
            <p>{{ item.desc }}</p>
          </div>
        </div>
        <div class="wrap-content" :style="index === 3 ? 'opacity: 1;z-index:999' : 'opacity: 0;z-index:0'">
          <div class="wrap-content-item" v-for="(item, index) in contentGroupA" @click="toDetail(item.url, item.per)">
            <h3>{{ item.tit }}</h3>
            <p>{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      index: 0,
      slidePos: "left:0px",
      wrapHeight: "height:415px",

      contentGroupA: [
        {
          tit: "混合云服务",
          desc: "与全球主流云厂商达成合作，为企业提供丰富的公有云资源和私有云建设服务",
          url: "/resource/CloudServices",
        },
        {
          tit: "托管云",
          desc: "一款可定制化托管的混合及专有云平台",
          url: "/resource/CloudLinkCloud",
        },
      ],
      contentGroupB: [
        {
          tit: "云数据同步服务",
          desc: "灵活打通云上线下连接",
          url: "/resource/WanCCS",
        },
        {
          tit: "IDC数据同步服务",
          desc: "数据中心连接服务",
          url: "/resource/WanDCS",
        },
        {
          tit: "等保测评",
          desc: "为企业提供一站式全流程的等保服务",
          url: "/resource/SafetyRule",
        },
        {
          tit: "企业信息安全",
          desc: "提供纵向和横向两个维度的安全产品，保障企业信息安全",
          url: "/resource/InfoSecurity",
        },
      ],
      contentGroupC: [
        {
          tit: "数据中心服务",
          desc: "“拎包入住”式服务器托管",
          url: "/resource/IdcDataCenter",
        },
        {
          tit: "服务模式",
          desc: "多种服务模式满足个性化需求",
          url: "/resource/IdcServiceModels",
        },
        {
          tit: "标准 / 增值服务",
          desc: "一站式运维体系",
          url: "/resource/IdcStaVaServices",
        },
        {
          tit: "IDC建设运营",
          desc: "集IDC设计规划、建设施工、运维管理、IDC产业园区一体化管理服务",
          url: "/resource/IdcCoop",
        },
      ],
      contentGroupG: [
        {
          tit: "算力服务",
          desc: "一站式GPU算力资源池",
          url: "/resource/ComputePower",
        },
      ],
    };
  },
  methods: {
    toDetail(url, per) {
      if (url && !per) {
        let a = document.createElement("a");
        a.setAttribute("href", url);
        a.setAttribute("id", "startTelMedicine");
        // 防止反复添加
        if (document.getElementById("startTelMedicine")) {
          document.body.removeChild(document.getElementById("startTelMedicine"));
        }
        document.body.appendChild(a);
        a.click();
      }
    },
    switchIndex(index) {
      this.index = index;
      if (index == 0) {
        this.slidePos = "left:0px";
        this.wrapHeight = "height:295px";
      } else if (index == 1) {
        this.slidePos = "left:235px";
        this.wrapHeight = "height:415px";
      } else if (index == 2) {
        this.slidePos = "left:465px";
        this.wrapHeight = "height:290px";
      } else if (index == 3) {
        this.slidePos = "left:695px";
        this.wrapHeight = "height:290px";
      }
    },
    toRe() {
      let routeData = this.$router.resolve({
        path: "resource/Container",
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>
<style lang="less" scoped>
.resource {
  width: 100%;
  min-width: 1200px;
  background-color: #fff;
  overflow: hidden;
}
.resource-main {
  height: 100%;
  width: 100%;
  .res-title {
    width: 1200px;
    margin: 0 auto;
    text-align: center;
    padding-top: 70px;
    h3 {
      font-size: 28px;
      // font-weight: 600;
      color: #262222;
    }
    p {
      margin-top: 20px;
      font-size: 16px;
      font-weight: 300;
      color: #aba1a2;
    }
  }
  .res-wrap {
    width: 1200px;
    margin: 0 auto;
    margin-top: 60px;
    transition: 0.3s;

    .wrap-box {
      width: 900px;
      height: 125px;
      margin: 0 auto;
      display: -webkit-flex; /* Safari */
      display: flex;
      justify-content: space-between;
      position: relative;
      border-bottom: 2px solid #f7f2f2;

      .wrap-item {
        width: 210px;
        height: 100%;
        text-align: center;
        position: relative;
        cursor: pointer;
        .wrap-pic {
          width: 75px;
          height: 75px;
          margin: 0 auto;
          background-color: #fff;
          i {
            font-size: 65px;
          }
        }
        .icon-active {
          background-image: -webkit-linear-gradient(90deg, #c01920, #e9531b);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        h3 {
          font-size: 18px;
          font-weight: 300;
          transition: all 0.3s;
        }
        &:hover {
          h3 {
            color: #b81c22;
          }
        }
      }
      .slide-bar {
        width: 200px;
        height: 6px;
        background-color: #b81c22;
        position: absolute;
        bottom: -4px;
        transition: 0.3s;
      }
    }

    .wrap-content {
      width: 860px;
      margin: 0 auto;
      padding: 30px 0px 0px 40px;
      background-color: #fff;
      display: -webkit-flex; /* Safari */
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      transition: all 0.5s;
      position: absolute;
      left: 170px;
      top: 135px;
      .wrap-content-item {
        width: 215px;
        margin-left: 85px;
        margin-bottom: 20px;
        cursor: pointer;
        h3 {
          font-size: 16px;
          line-height: 40px;
          color: #3b3435;
          transition: all 0.3s;
        }
        p {
          width: fit-content;
          text-align: justify;
          max-width: 195px;
          font-size: 14px;
          line-height: 26px;
          font-weight: 300;
          transition: all 0.3s;
          color: #aba1a2;
        }
        &:hover {
          h3 {
            color: #b81c22;
          }
          p {
            color: #3b3435;
          }
        }
        &:nth-of-type(3n + 1) {
          margin-left: 0;
        }
      }
      .single {
        cursor: default;
        &:hover {
          h3 {
            color: #3b3435;
          }
        }
      }
      .wrap-content-item:nth-child(4) {
        margin-right: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/home/components/resource.vue